import { Flex, FlexProps } from '@chakra-ui/react'
import { motion, MotionProps } from 'framer-motion'
import { ForwardRefExoticComponent } from 'react'

export const MFlex = motion.create(
  Flex as ForwardRefExoticComponent<FlexProps>,
) as ForwardRefExoticComponent<Omit<FlexProps, 'style'> & MotionProps>
